export const gtag = (event: object): void => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}
